import request from '@/utils/request'

export function getSupplyChainDashboard() {
  return request({
    url: '/supply-chain-api/supply-chain/dashboard',
    method: 'get',
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function getSupplyChainSankeyGraph(params) {
  return request({
    url: '/supply-chain-api/supplyChain/sankey/graph',
    method: 'get',
    params,
    headers: {
      Accept: '*/*'
    }
  })
}

export function getSupplyChainCustomerList(params) {
  return request({
    url: '/supply-chain-api/supplyChain/sankey/customerList',
    method: 'get',
    params,
    headers: {
      Accept: '*/*'
    }
  })
}

export function addMaterialPriceChange(data) {
  return request({
    url: '/supply-chain-api/supplyChain/materialPriceChangeLog/add',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function queryMaterialPriceChanges(data = {}) {
  return request({
    url: '/supply-chain-api/supplyChain/materialPriceChangeLog/query',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getMaterialPriceChangeDetail(id) {
  return request({
    url: `/supply-chain-api/supplyChain/materialPriceChangeLog/get/${id}`,
    method: 'get'
  })
}

export function deleteMaterialPriceChange(id) {
  return request({
    url: `/supply-chain-api/supplyChain/materialPriceChangeLog/delete/${id}`,
    method: 'get'
  })
}

export function updateMaterialPriceChangeStatus(data) {
  return request({
    url: '/supply-chain-api/supplyChain/materialPriceChangeLog/updateStatus',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function analyzeAndCreateMaterialPriceDecision(businessId) {
  return request({
    url: `/supply-chain-api/supplyChain/materialPriceChangeLog/analyzeAndCreateDecision/${businessId}`,
    method: 'get'
  })
}

export function queryLakeSuppliers(data) {
  return request({
    url: '/supply-chain-api/open/dataview/lakeQuerySuppliers',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function queryLakeMaterialsBySupplier(data) {
  return request({
    url: '/supply-chain-api/open/dataview/lakeQueryMaterialsBySupplier',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
